// Request queue utilities
import { PRIORITY } from "../constants.js";

export class RequestQueue {
  constructor() {
    this.queue = [];
    this.isProcessing = false;
  }

  /**
   * Queues a request. Returns a Promise that resolves when THIS request has
   * finished processing (or rejects if it throws), allowing callers to await
   * a specific flush.
   */
  add(request, priority = PRIORITY.NORMAL) {
    return new Promise((resolve, reject) => {
      this.queue.push({ request, priority, resolve, reject });
      this.queue.sort((a, b) => a.priority - b.priority);
      this.process();
    });
  }

  async process() {
    if (this.isProcessing || this.queue.length === 0) return;
    this.isProcessing = true;

    const { request, resolve, reject } = this.queue.shift();
    try {
      const result = await request();
      resolve(result);
    } catch (error) {
      reject(error);
    } finally {
      this.isProcessing = false;
      this.process();
    }
  }
}